(function() {
  // Custom slider for cozy-grid section
  function initCustomSlider(sliderWrapper) {
    if (!sliderWrapper) return;
    
    const sliderTrack = sliderWrapper.querySelector('.highlight-grid__slider-track');
    const sliderContainer = sliderWrapper.querySelector('.highlight-grid__slider-container');
    const sliderNav = sliderWrapper.closest('.highlight-grid__cards-wrapper')?.querySelector('.highlight-grid__slider-nav');
    const prevBtn = sliderNav?.querySelector('.highlight-grid__slider-btn--prev');
    const nextBtn = sliderNav?.querySelector('.highlight-grid__slider-btn--next');
    const slides = sliderContainer.querySelectorAll('.highlight-grid__card');
    
    if (!sliderTrack || !sliderContainer || slides.length === 0) return;
    
    // Each slider has its own state
    let currentPosition = 0;
    let isAnimating = false;
    let startX = 0;
    let currentX = 0;
    let isDragging = false;
    let hasMoved = false;
    let touchStartTarget = null;
    let touchStartPosition = 0;
    let mouseDown = false;
    let mouseStartX = 0;
    
    // Get settings
    const mobileColumns = parseFloat(sliderWrapper.dataset.mobileColumns) || 1.5;
    const tabletColumns = parseInt(sliderWrapper.dataset.tabletColumns) || 2;
    const desktopColumns = parseInt(sliderWrapper.dataset.desktopColumns) || 3;
    
    // Calculate sizes
    function getSlidesPerView() {
      if (window.innerWidth <= 767) {
        return 1;
      }
      let columns = mobileColumns;
      if (window.innerWidth >= 1024) {
        columns = desktopColumns;
      } else if (window.innerWidth >= 768) {
        columns = tabletColumns;
      }
      return columns;
    }
    
    function getSlideWidth() {
      const containerWidth = sliderTrack.offsetWidth;
      
      // Mobile: card 82.5% width
      if (window.innerWidth <= 767) {
        return containerWidth * 0.825;
      }
      
      const gap = 20;
      const maxCardWidth = 255;
      const columns = getSlidesPerView();
      
      // Calculate slide width considering max card width
      const calculatedWidth = (containerWidth - (gap * (columns - 1))) / columns;
      const slideWidth = Math.min(calculatedWidth, maxCardWidth);
      
      return slideWidth;
    }
    
    function getMaxScroll() {
      const containerWidth = sliderTrack.offsetWidth;
      const totalSlides = slides.length;
      
      if (totalSlides === 0) return 0;
      
      if (window.innerWidth <= 767) {
        // Mobile: calculate based on actual card widths
        if (totalSlides <= 1) {
          return 0;
        }
        
        // Get actual container width
        const actualContainerWidth = sliderTrack.offsetWidth;
        
        // Calculate total width of all cards
        let totalCardsWidth = 0;
        const gap = 12;
        
        // Sum up actual widths of all cards
        slides.forEach((slide, index) => {
          const cardWidth = slide.offsetWidth || (actualContainerWidth * 0.825);
          totalCardsWidth += cardWidth;
          if (index < totalSlides - 1) {
            totalCardsWidth += gap;
          }
        });
        
        // If all cards fit, no scrolling needed
        if (totalCardsWidth <= actualContainerWidth) {
          return 0;
        }
        
        // Calculate max scroll: total width - visible width
        const maxScroll = totalCardsWidth - actualContainerWidth;
        
        return Math.max(0, maxScroll);
      }
      
      // Desktop mode - calculate based on actual card positions
      const gap = 20;
      const maxCardWidth = 255;
      const columns = getSlidesPerView();
      const calculatedWidth = (containerWidth - (gap * (columns - 1))) / columns;
      const cardWidth = Math.min(calculatedWidth, maxCardWidth);
      
      // Calculate total width of all cards including gaps
      const totalCardsWidth = (cardWidth * totalSlides) + (gap * (totalSlides - 1));
      
      // Get actual visible width of container (sliderTrack width)
      const actualVisibleWidth = sliderTrack.offsetWidth;
      
      // Account for padding-left on desktop (40px)
      const paddingLeft = window.innerWidth > 767 ? 40 : 0;
      const effectiveVisibleWidth = actualVisibleWidth - paddingLeft;
      
      // If all cards fit in visible area, no scrolling needed
      if (totalCardsWidth <= effectiveVisibleWidth) {
        return 0;
      }
      
      // Calculate how much we can scroll
      // Max scroll = total width - visible width (without padding)
      const maxScroll = totalCardsWidth - effectiveVisibleWidth;
      
      return Math.max(0, maxScroll);
    }
    
    function updateButtons() {
      const maxScroll = getMaxScroll();
      const isAtStart = currentPosition <= 1;
      const isAtEnd = currentPosition >= maxScroll - 1;
      
      // Hide navigation if all cards are visible (no scrolling needed)
      // This applies to all devices - if maxScroll <= 1, all cards fit and no navigation needed
      const needsScrolling = maxScroll > 1;
      
      if (sliderNav) {
        if (needsScrolling) {
          sliderNav.style.display = 'flex';
        } else {
          sliderNav.style.display = 'none';
        }
      }
      
      if (prevBtn) {
        prevBtn.disabled = isAtStart || maxScroll <= 1;
      }
      
      if (nextBtn) {
        nextBtn.disabled = isAtEnd || maxScroll <= 1;
      }
    }
    
    function scrollTo(position, animate = true) {
      if (isAnimating) return;
      
      const maxScroll = getMaxScroll();
      
      // If maxScroll is 0 or very small, ensure we stay at 0
      if (maxScroll <= 1) {
        currentPosition = 0;
        sliderContainer.style.transform = 'translateX(0)';
        if (!animate) {
          sliderContainer.style.transition = 'none';
        }
        updateButtons();
        return;
      }
      
      // Clamp position to valid range - never exceed maxScroll
      currentPosition = Math.max(0, Math.min(maxScroll, position));
      
      if (animate) {
        isAnimating = true;
        sliderContainer.style.transition = 'transform 0.3s ease-out';
      } else {
        sliderContainer.style.transition = 'none';
      }
      
      sliderContainer.style.transform = `translateX(-${currentPosition}px)`;
      
      if (animate) {
        setTimeout(() => {
          isAnimating = false;
          updateButtons();
        }, 300);
      } else {
        updateButtons();
      }
    }
    
    function slideNext() {
      const maxScroll = getMaxScroll();
      if (currentPosition >= maxScroll) return; // Already at end
      
      const cardWidth = getSlideWidth();
      const slidesPerView = getSlidesPerView();
      const gap = window.innerWidth <= 767 ? 12 : 20;
      const step = window.innerWidth <= 767 
        ? cardWidth + gap 
        : (cardWidth * slidesPerView) + (gap * slidesPerView);
      
      const newPosition = currentPosition + step;
      scrollTo(Math.min(newPosition, maxScroll));
    }
    
    function slidePrev() {
      if (currentPosition <= 0) return; // Already at start
      
      const cardWidth = getSlideWidth();
      const slidesPerView = getSlidesPerView();
      const gap = window.innerWidth <= 767 ? 12 : 20;
      const step = window.innerWidth <= 767 
        ? cardWidth + gap 
        : (cardWidth * slidesPerView) + (gap * slidesPerView);
      
      const newPosition = currentPosition - step;
      scrollTo(Math.max(0, newPosition));
    }
    
    // Button handlers
    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (currentPosition > 0) {
          slidePrev();
        }
      });
    }
    
    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        slideNext();
      });
    }
    
    // Mouse drag support for desktop
    const handleMouseMove = function(e) {
      if (!mouseDown || !isDragging) return;
      currentX = e.clientX;
      const diff = startX - currentX;
      
      if (Math.abs(diff) > 5) {
        hasMoved = true;
      }
      
      const newPosition = currentPosition + diff;
      const maxScroll = getMaxScroll();
      const constrainedPosition = Math.max(0, Math.min(maxScroll, newPosition));
      sliderContainer.style.transform = `translateX(-${constrainedPosition}px)`;
    };
    
    const handleMouseUp = function(e) {
      if (!mouseDown) return;
      mouseDown = false;
      sliderTrack.style.cursor = '';
      
      if (!isDragging) return;
      
      const diff = startX - currentX;
      const threshold = 50;
      
      const clickedElement = touchStartTarget;
      const isClickOnCard = clickedElement && (
        clickedElement.closest('.highlight-grid__card') !== null
      );
      
      if (isClickOnCard && !hasMoved) {
        const card = clickedElement.closest('.highlight-grid__card');
        if (card) {
          const link = card.href;
          if (link && link !== '#') {
            window.location.href = link;
            return;
          }
        }
      }
      
      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          slideNext();
        } else {
          slidePrev();
        }
      } else {
        scrollTo(currentPosition);
      }
      
      isDragging = false;
      hasMoved = false;
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
    
    sliderTrack.addEventListener('mousedown', function(e) {
      if (e.button !== 0) return;
      mouseDown = true;
      mouseStartX = e.clientX;
      startX = e.clientX;
      touchStartTarget = e.target;
      sliderTrack.style.cursor = 'grabbing';
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    });
    
    // Touch support for mobile
    sliderTrack.addEventListener('touchstart', function(e) {
      touchStartPosition = e.touches[0].clientX;
      touchStartTarget = e.target;
      startX = e.touches[0].clientX;
      hasMoved = false;
    }, { passive: true });
    
    sliderTrack.addEventListener('touchmove', function(e) {
      if (!touchStartPosition) return;
      const currentTouch = e.touches[0].clientX;
      const diff = touchStartPosition - currentTouch;
      
      if (Math.abs(diff) > 5) {
        hasMoved = true;
      }
      
      const newPosition = currentPosition + diff;
      const maxScroll = getMaxScroll();
      const constrainedPosition = Math.max(0, Math.min(maxScroll, newPosition));
      sliderContainer.style.transform = `translateX(-${constrainedPosition}px)`;
      sliderContainer.style.transition = 'none';
    }, { passive: true });
    
    sliderTrack.addEventListener('touchend', function(e) {
      if (!touchStartPosition) return;
      const currentTouch = e.changedTouches[0].clientX;
      const diff = touchStartPosition - currentTouch;
      const threshold = 50;
      
      const clickedElement = touchStartTarget;
      const isClickOnCard = clickedElement && (
        clickedElement.closest('.highlight-grid__card') !== null
      );
      
      if (isClickOnCard && !hasMoved) {
        const card = clickedElement.closest('.highlight-grid__card');
        if (card) {
          const link = card.href;
          if (link && link !== '#') {
            window.location.href = link;
            touchStartPosition = 0;
            return;
          }
        }
      }
      
      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          slideNext();
        } else {
          slidePrev();
        }
      } else {
        scrollTo(currentPosition);
      }
      
      touchStartPosition = 0;
      sliderContainer.style.transition = 'transform 0.3s ease-out';
    }, { passive: true });
    
    // Initialize
    function init() {
      updateButtons();
      updateSlideSizes();
    }
    
    function updateSlideSizes() {
      const cardWidth = getSlideWidth();
      slides.forEach(slide => {
        if (window.innerWidth <= 767) {
          slide.style.width = '82.5%';
          slide.style.maxWidth = '82.5%';
        } else {
          slide.style.width = `${cardWidth}px`;
          slide.style.maxWidth = '255px';
        }
      });
    }
    
    // Handle resize
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        currentPosition = 0;
        scrollTo(0, false);
        updateSlideSizes();
        updateButtons();
      }, 250);
    });
    
    // Initialize on load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }
  
  // Initialize all sliders on page load
  function initAllSliders() {
    const sliders = document.querySelectorAll('.highlight-grid__slider');
    sliders.forEach(slider => {
      initCustomSlider(slider);
    });
  }
  
  // Initialize on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSliders);
  } else {
    initAllSliders();
  }
  
  // Re-initialize when Shopify theme editor loads new sections
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      if (event.detail.sectionId) {
        const section = document.querySelector(`[data-section-id="${event.detail.sectionId}"]`);
        if (section) {
          const slider = section.querySelector('.highlight-grid__slider');
          if (slider) {
            initCustomSlider(slider);
          }
        }
      }
    });
  }
})();


